module.exports = __webpack_public_path__ + "assets/slike/tenkovi/nemacki-tenk-podnozje.3337c1c82136078fe0ec6a40f2095774.png";


//////////////////
// WEBPACK FOOTER
// ./assets/slike/tenkovi/nemacki-tenk-podnozje.png
// module id = 39
// module chunks = 0